export default __webpack_public_path__ + "static/media/gojelly_site_bg_02.07858da9.jpg";